module.exports = __webpack_public_path__ + "static/media/love.a37c5d0b.png";